<template>
  <div>
    <popup-hint hint="categories">
      <template v-slot:breadcrumbs>
        <breadcrumbs :back="[back]" home="Categories"/>
      </template>
      <template v-slot:top>
        Categories can be used to group {{type}}s of the same type.
        This can make it easier to manage your inventory.
      </template>
    </popup-hint>

    <purtrak-table name="categories" objectType="categories" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   listEndPoint="categories2"
                   fields="id,name,parent{id}"
                   :listFilters="[]" :parameters="[{name:'type', value:type}]"
                   @list="formatList"
                   @dblclick="category => $router.push({name:'EquipmentFermentersTransactions',params:{type,cateogryId:category.id}})"
                   title="Categories"
                   :print-info="{pageSize:'portrait'}"
                   download-endpoint="categoriesExportCSV">
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'InventoryCategoriesEditNew',params:{type}}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.name="{item,printing}">
        <template v-if="printing">{{item.name}}</template>
        <span v-else :style="'margin-left:'+item.level*20+'px'">
          <v-hover v-if="!readOnly" v-slot="{hover}">
            <a @click.stop="$router.push({name:'InventoryCategoriesEdit',params:{type,categoryId:item.id}})"
               :class="{'text-decoration-underline':hover}">{{item.name}}</a>
          </v-hover>
        </span>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="220" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Category operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <template v-if="company.allowAudit && company.permissions.includes('audit')">
              <v-list-item :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
              <v-divider/>
            </template>
            <template v-if="!readOnly">
              <v-list-item :to="{name:'InventoryCategoriesEdit',params:{type,categoryId:item.id}}"><v-list-item-title>Edit category</v-list-item-title></v-list-item>
              <v-list-item @click="category=item;showDelete=true"><v-list-item-title>Delete category</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="category.name" @delete="performDeleteCategory"/>
  </div>
</template>

<script>
import createHierarchyList from '@/mixins/createHierarchyList'

export default {
  name: 'InventoryCategories',
  mixins: [createHierarchyList],
  props: {
    type: {type:String, required:true}
  },
  data () {
    return {
      category: {},
      showDelete: false,
      defaultColumns: [{ value: 'name', visible:true}],
      headers: [{ text: 'CATEGORY', value: 'name', width:'95%',sortable:false}]
    }
  },
  computed: {
    back() {
      const backs = new Map([
        ['Item', {text:'Items and services',to:{name:'InventoryItems'}}],
        ['Product', {text:'Products',to:{name:'InventoryProducts'}}],
        ['Customer', {text:'Customers',to:{name:'SalesCustomers'}}]
      ]);
      return backs.get(this.type);
    },
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('inventory.write');
    }
  },
  methods: {
    formatList({list:{edges}}) {
      edges.forEach(edge => {
        const level = edge.node.parent?.id ? edges.find(e => e.node.id === edge.node.parent.id).node.level+1 : 0;
        edge.node.level = level;
      });
    },
    async performDeleteCategory() {
      this.loading = true;
      const results = await this.$apiCall(`mutation InventoryCategories($id: ID!) {
                                             objectDelete(id:$id)
                                            }`,
                                          {id:this.category.id});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        this.$refs.table.buildList();
        this.$store.commit('setError', {type:'success',message:`Deleted category ${this.category.name}`});
      }
    }
  }
}
</script>